import React from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { downloadFileFromS3 } from '../userManual/manualsData';
import './IntroVideo.scss';

const S3_PROMO_VIDEO_URL =
  'https://prod-dmrc-bucket.s3.ap-south-1.amazonaws.com/DMRC%20HRMS%20Employee%20App%20Promo%20HIGHLIGHTS%20v8/DMRC%20HRMS%20Employee%20App%20Promo%20HIGHLIGHTS%20v8.mp4';
const PROMO_VIDEO_NAME = 'DMRC HRMS Employee App Promo HIGHLIGHTS v8.mp4';

const IntroVideo: React.FC = () => {
  return (
    <div className="dmrc-intro-page">
      {/* Top Navbar */}
      <nav className="intro-navbar">
        <div className="container-fluid px-lg-4 px-3">
          <div className="intro-navbar-inner">
            <Link to={all_routes.login} className="brand-container">
              <ImageWithBasePath
                src="assets/img/dmrc-metro-logo.svg"
                alt="Delhi Metro Logo"
                className="brand-logo-img"
                height={36}
                width={36}
              />
              <div className="brand-text-block">
                <div className="brand-title-row">
                  <span className="brand-title">DMRC HRMS</span>
                  <span className="brand-badge d-none d-sm-inline-flex">Intro Video</span>
                </div>
                <span className="brand-subtitle d-none d-md-inline">
                  Delhi Metro Rail Corporation
                </span>
              </div>
            </Link>

            <div className="nav-action-group">
              <Link to={all_routes.userManual} className="btn-nav-manuals" title="Browse User Manuals & SOPs">
                <i className="ti ti-book" />
                <span className="d-none d-md-inline">User Manuals & SOPs</span>
                <span className="d-none d-sm-inline d-md-none">User Manuals</span>
                <span className="d-sm-none">Manuals</span>
              </Link>
              <Link to={all_routes.login} className="btn-login-header">
                <i className="ti ti-login" />
                <span className="d-none d-sm-inline">Employee Login</span>
                <span className="d-sm-none">Login</span>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content Body */}
      <div className="intro-main-body">
        <div className="container-fluid px-lg-4 px-3">
          {/* Header Block */}
          <div className="intro-page-header">
            <ul className="breadcrumb-list">
              <li>
                <Link to={all_routes.login}>Home</Link>
              </li>
              <li className="crumb-sep">/</li>
              <li>
                <Link to={all_routes.userManual}>Employee Services</Link>
              </li>
              <li className="crumb-sep">/</li>
              <li className="active-crumb">Introduction Video</li>
            </ul>

            <h3 className="header-title-text">DMRC HRMS Employee App Walkthrough & Highlights</h3>
            <p className="header-subtitle-text">
              Official video introduction showcasing the all-new DMRC HRMS web portal and mobile application.
            </p>
          </div>

          {/* Video Showcase Player Card */}
          <div className="video-showcase-card">
            <div className="video-screen-container">
              <video
                controls
                autoPlay
                playsInline
                src={S3_PROMO_VIDEO_URL}
                poster="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80"
              >
                <source src={S3_PROMO_VIDEO_URL} type="video/mp4" />
                Your browser does not support HTML5 video playback.
              </video>
            </div>

            <div className="video-info-bar">
              <div className="video-meta-left">
                <span className="meta-badge">
                  <i className="ti ti-sparkles me-1" /> Official App Promo V8
                </span>
                <h4 className="video-meta-title">DMRC HRMS Employee App Promo HIGHLIGHTS (V8)</h4>
                <p className="video-meta-desc">
                  Learn how to navigate your profile, mark attendance, submit leave, download payslips, and access HR services.
                </p>
              </div>

              <div className="video-actions-right">
                <button
                  type="button"
                  className="btn-action-download"
                  onClick={() => downloadFileFromS3(S3_PROMO_VIDEO_URL, PROMO_VIDEO_NAME)}
                  title="Download MP4 Video"
                >
                  <i className="ti ti-download" />
                  <span>Download MP4</span>
                </button>

                <Link
                  to={all_routes.userManual}
                  className="btn-action-manuals"
                  title="Browse All User Manuals & SOPs"
                >
                  <i className="ti ti-files" />
                  <span>Browse Manuals</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="intro-footer text-center">
        <div className="container-fluid px-lg-4 px-3">
          <div className="footer-row">
            <div>
              &copy; {new Date().getFullYear()} Delhi Metro Rail Corporation (DMRC). All rights reserved.
            </div>
            <div className="footer-links">
              <Link to={all_routes.userManual}>User Manuals & SOPs</Link>
              <Link to={all_routes.privacyPolicy}>Privacy Policy</Link>
              <Link to={all_routes.login}>Employee Login</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default IntroVideo;
